/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'fawn',
    quality: 0.2,
    mana: 1,
    dexterity: 1
}